module.exports = __webpack_public_path__ + "static/media/9DESA34.50b2ea1c.jpg";